<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     版本定价
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="upgrade">
    <div class="title">助力企业数字化转型</div>
    <div class="text-center text-secondary mt-lg">全新一代物联网内核引擎</div>
    <div class="flex justify-content-center">
      <div class="case-box">
        <div class="case-card free-card">
          <div class="top">
            <div class="case-title">免费版</div>
            <div class="case-desc">满足日常设备监控和管理需求</div>
            <div class="price-area"></div>
            <div class="contact-btn">当前版本</div>
          </div>
          <div class="bottom">
            <div v-for="(pri,index) in privilegies" :key="index">
              <div class="title-1">{{ pri.title }}</div>
              <div
                v-for="(op,ind) in pri.option"
                :key="'item' + ind"
                class="flex align-items-center op-item"
              >
                <div class="bd tilte-2">{{ op.title }}</div>
                <div class="ft value-style">
                  <div v-if="op.show">{{ op.value['free'] }}</div>
                  <div v-else class="font-lg">
                    <i v-if="op.value['free']" class="iconfont icon-tick"></i>
                    <i v-else class="el-icon-close text-danger"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="contact-btn">当前版本</div>
          </div>
        </div>
      </div>
      <!-- <div class="case-box">
        <div class="case-card firma-card">
          <div class="top">
            <div class="case-title">企业版</div>
            <div class="case-desc">享受品牌打造和增值特权</div>
            <div class="price-area">
              <div v-if="market_price != selling_price && market_price > 0" class="origin-price">￥{{market_price}}</div>
              <div class="now-price">￥{{selling_price}}</div>
            </div>
            <div class="contact-btn" @click="$contactus()">立即咨询</div>
          </div>
          <div class="bottom">
            <div v-for="(pri,index) in privilegies" :key="index">
              <div class="title-1">{{ pri.title }}</div>
              <div
                v-for="(op,ind) in pri.option"
                :key="'item' + ind"
                class="flex align-items-center op-item"
              >
                <div class="bd tilte-2">{{ op.title }}</div>
                <div class="ft value-style">
                  <div v-if="op.show">{{ op.value['firma'] }}</div>
                  <div v-else class="font-lg">
                    <i v-if="op.value['firma']" class="iconfont icon-tick"></i>
                    <i v-else class="el-icon-close text-danger"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="contact-btn" @click="$contactus()">立即咨询</div>
          </div>
        </div>
      </div> -->
      <div class="case-box">
        <div class="case-card private-card">
          <div class="top">
            <div class="case-title">私有部署</div>
            <div class="case-desc">为企业定制上云服务</div>
            <div class="price-area"></div>
            <div class="contact-btn" @click="$contactus()">立即咨询</div>
          </div>
          <div class="bottom">
            <div v-for="(pri,index) in privilegies" :key="index">
              <div class="title-1">{{ pri.title }}</div>
              <div
                v-for="(op,ind) in pri.option"
                :key="'item' + ind"
                class="flex align-items-center op-item"
              >
                <div class="bd tilte-2">{{ op.title }}</div>
                <div class="ft value-style">
                  <div v-if="op.show">{{ op.value['private'] }}</div>
                  <div v-else class="font-lg">
                    <i v-if="op.value['private']" class="iconfont icon-tick"></i>
                    <i v-else class="el-icon-close text-danger"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="contact-btn" @click="$contactus()">立即咨询</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { aiotversionGetApi } from "@/api/ei/eiApi";

export default {
  data() {
    return {
      privilegies: [
      {
          title: "使用限制",
          option: [
            {
              title: "设备数量",
              show: 1,
              value: {
                free: "无限制",
                firma: "无限制",
                private: "无限制",
              },
            },
            {
              title: "模型数量",
              show: 1,
              value: {
                free: 10,
                firma: 1000,
                private: "无限制",
              },
            },
            {
              title: "数据采集频率",
              show: 1,
              value: {
                free: "≥ 60秒",
                firma: "≥ 30秒",
                private: "无限制",
              },
            },
            {
              title: "数据存储天数",
              show: 1,
              value: {
                free: "＜ 7天",
                firma: "＜ 7天(按需扩容)",
                private: "无限制",
              },
            },
            {
              title: "云计算能力",
              show: 1,
              value: {
                free: "共享",
                firma: "专享",
                private: "独享",
              },
            },
            {
              title: "开放接口OpenAPI",
              show: 1,
              value: {
                free: "不支持",
                firma: "支持",
                private: "支持",
              },
            },
          ],
        },
        {
          title: "功能对比",
          option: [
            {
              title: "实时数据监控",
              value: {
                free: 1,
                firma: 1,
                private: 1,
              },
            },
            {
              title: "历史数据查看",
              value: {
                free: 1,
                firma: 1,
                private: 1,
              },
            },
            {
              title: "报警消息通知",
              value: {
                free: 1,
                firma: 1,
                private: 1,
              },
            },
            {
              title: "态势感知大屏",
              value: {
                free: 1,
                firma: 1,
                private: 1,
              },
            },
            {
              title: "一物一码功能",
              value: {
                free: 0,
                firma: 1,
                private: 1,
              },
            },
            {
              title: "品牌公众号对接",
              value: {
                free: 0,
                firma: 1,
                private: 1,
              },
            },
            {
              title: "品牌个性化定制",
              value: {
                free: 0,
                firma: 1,
                private: 1,
              },
            },
            {
              title: "增值盈利功能",
              value: {
                free: 0,
                firma: 1,
                private: 1,
              },
            },
            {
              title: "在线商城功能",
              value: {
                free: 0,
                firma: 1,
                private: 1,
              },
            },
            {
              title: "其他定制功能",
              value: {
                free: 0,
                firma: 0,
                private: 1,
              },
            },
          ],
        },
        {
          title: "权益对比",
          option: [
            {
              title: "平台永久免费升级",
              value: {
                free: 1,
                firma: 1,
                private: 1,
              },
            },
            {
              title: "厂商免费使用特权",
              value: {
                free: 0,
                firma: 1,
                private: 1,
              },
            },
            {
              title: "专属顾问技术支持",
              value: {
                free: 0,
                firma: 1,
                private: 1,
              },
            },
            {
              title: "建议功能优先处理",
              value: {
                free: 0,
                firma: 1,
                private: 1,
              },
            },
          ],
        },
      ],

      market_price: 0,
      selling_price: 0,
    };
  },

  created() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      aiotversionGetApi().then((res) => {
        if (!res.errno) {
          this.market_price = res.data.market_price;
          this.selling_price = res.data.selling_price;
        } else {
          this.$message.error(res.message);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.upgrade {
  background: url(../../assets/upgrade-bg.jpg) no-repeat;
  margin: 0 -20px;
  height: calc(100vh - 60px);
  overflow: auto;
  padding-bottom: 200px;
  .title {
    padding-top: 70px;
    color: rgba(16, 16, 16, 1);
    font-size: 48px;
    text-align: center;
  }
  .text-secondary {
    font-size: 24px;
  }
  .case-box {
    margin: 76px 15px 0;
    box-shadow: 0px 1px 20px 0px rgba(238, 240, 245, 1);
    border-radius: 10px;
    .contact-btn {
      width: 200px;
      padding: 10px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0 auto;
      border-radius: 4px;
      font-size: 16px;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }
    .case-card {
      width: 374px;
      border-radius: 10px;
      transition: all 0.3s;
      .price-area {
        margin: 0 auto;
        min-height: 132px;
        padding: 30px;
        text-align: center;
        .origin-price {
          font-size: 18px;
          color: #fff;
          text-decoration: line-through;
        }
        .now-price {
          font-size: 36px;
          color: #fff;
        }
        .origin-price {
          color: rgba(255, 255, 255, 0.8);
          font-size: 18px;
          text-decoration: line-through;
        }
      }
      .top {
        border-radius: 10px 10px 0px 0px;
        padding-bottom: 50px;
      }
      .bottom {
        padding: 0 35px 45px;
        background-color: #fff;
        border-radius: 0 0 10px 10px;
        .title-1 {
          padding: 30px 0;
          font-size: 20px;
          border-bottom: 1px solid rgba(238, 240, 245, 1);
        }

        .op-item {
          padding: 20px 0;
          .title-2 {
            font-size: 16px;
          }
          .value-style {
            font-size: 20px;
            color: #07c160;
          }
        }

        .contact-btn {
          margin-top: 30px;
        }
      }
      &.free-card {
        .top {
          background: url(../../assets/free-bg.jpg) no-repeat;
        }

        .contact-btn {
          background-color: #eef0f5;
          color: #909399;
          cursor: auto;
          &:hover {
            opacity: 1;
          }
        }
      }

      &.firma-card {
        &:hover {
          box-shadow: 0 10px 32px 0 rgba(0, 0, 0, 0.24);
          transform: scale(1.02);
        }
        .top {
          background: url(../../assets/firma-bg.png) no-repeat;
        }
        .contact-btn {
          background-color: #ffffff;
          color: #07c160;
        }
        .bottom {
          .contact-btn {
            background-color: #409EFF;
            color: #fff;
          }
        }
      }

      &.private-card {
        &:hover {
          box-shadow: 0 10px 32px 0 rgba(0, 0, 0, 0.24);
          transform: scale(1.02);
        }
        .top {
          background: url(../../assets/private-bg.jpg) no-repeat;
        }
        .contact-btn {
          background-color: #ffd4af;
        }
      }

      .case-title {
        padding-top: 36px;
        text-align: center;
        font-size: 36px;
        color: #fff;
      }

      .case-desc {
        padding-top: 36px;
        font-size: 14px;
        text-align: center;
        color: #fff;
      }
    }
  }
}
</style>
